import * as Yup from 'yup';

const TASK_SCHEMA = Yup.object().shape({
  title: Yup.string().required('Required'),
});

export default TASK_SCHEMA